export function getConciergerieDisplayState({
  enabled,
  hasLender,
  hasResponses,
  noCandidates,
  isSearching,
  hasContactedAll,
}: {
  enabled: boolean;
  hasLender: boolean;
  hasResponses: boolean;
  noCandidates: boolean;
  isSearching: boolean;
  hasContactedAll: boolean;
}) {
  if (!enabled) return { extension: 'Disabled', enableAnimation: false };

  let extension = '';
  if (hasLender) extension = 'HasLender';
  else if (hasResponses) extension = 'WithResponses';
  else if (noCandidates) extension = 'NoCandidates';
  else if (isSearching) extension = 'Searching';
  else if (hasContactedAll) extension = 'ContactedAll';

  return { extension, enableAnimation: !hasLender && (isSearching || !hasContactedAll) };
}
